DocumentCEValidator.$inject = ['validator'];

export default function DocumentCEValidator(validator) {
    const instance = new validator();
    return instance;
}
